"use strict";
// Copyright © Veeam Software Group GmbH.
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastChannel = void 0;
const BC_PREFIX = 'BroadcastChannel_';
class BroadcastChannelPolyfill {
    constructor(name) {
        this.closed = false;
        this.unsubscribeCallbacks = () => { };
        this.channelId = BC_PREFIX + name;
        this.name =
            this.channelId +
                `_${BroadcastChannelPolyfill.getRandomString()}_${BroadcastChannelPolyfill.getTimestamp()}`;
        const handler = this.onMessageHandler.bind(this);
        window.addEventListener('storage', handler, false);
        this.unsubscribeCallbacks = () => {
            window.removeEventListener('storage', handler);
        };
    }
    static getTimestamp() {
        return new Date().getTime();
    }
    static getRandomString(length = 5) {
        let result = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < length; i++) {
            result += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return result;
    }
    onMessageHandler(event) {
        var _a;
        const key = (_a = event.key) !== null && _a !== void 0 ? _a : '';
        const { newValue } = event;
        const isRemoved = !newValue;
        if (!isRemoved) {
            try {
                const data = JSON.parse(newValue !== null && newValue !== void 0 ? newValue : '{}');
                if (data.channelId === this.channelId) {
                    if (!this.closed) {
                        this.onmessage(data.message);
                    }
                    window.localStorage.removeItem(key);
                }
            }
            catch (err) {
                throw err;
            }
        }
    }
    buildResponse(data) {
        return {
            timestamp: BroadcastChannelPolyfill.getTimestamp(),
            isTrusted: true,
            target: null,
            currentTarget: null,
            data: data,
            bubbles: false,
            cancelable: false,
            defaultPrevented: false,
            lastEventId: '',
            origin: window.location.origin,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onmessage(messageEvent) { }
    postMessage(data) {
        if (this.closed) {
            return;
        }
        const key = BroadcastChannelPolyfill.getRandomString() + '_' + this.channelId;
        try {
            window.localStorage.setItem(key, JSON.stringify({
                channelId: this.channelId,
                message: this.buildResponse(data),
            }));
        }
        catch (err) {
            throw err;
        }
        setTimeout(() => {
            window.localStorage.removeItem(key);
        }, 1000);
    }
    close() {
        this.closed = true;
        this.unsubscribeCallbacks();
    }
}
exports.BroadcastChannel = (_a = window.BroadcastChannel) !== null && _a !== void 0 ? _a : BroadcastChannelPolyfill;
//# sourceMappingURL=BroadcastChannel.js.map